/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import {
  setMultipleEntity,
  setShowReloginModalFalse,
} from "../../redux/features/login/login";
import { xpentraLogoutSliceReset } from "../../redux/features/logout/logout";
import { conciergeLogin } from "../../redux/features/multientity/multientity";
import { triggerEntityChange } from "../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { logout } from "../../redux/features/refreshToken/refreshToken";
import { toast_position } from "../../redux/features/Settings/Authorization";
import CONFIG from "../../utils/globalText";
import Entity from "./Entity";
import EntityDetailsBox from "./EntityDetailBox";
import MultiEntityPopup from "./MultiEntityPopup";
import SVGComponent from "../_utils/SVGComponent";
import {
  GlobalConfiguration,
  ScreenSizeConfiguration,
} from "../../utils/configurationProvider";
import CommonToast from "../_utils/CommonToast";
import ICONS from "../../assets/Icons";

const EditWithWhiteCircleIcon = ICONS?.EDIT_WITH_WHITE_CIRCLE;
const SwapEntityIconWithCircle = ICONS?.SWAP_ENTITY_WHITE_CIRCLE;
const SwapEntityIcon = ICONS?.SWAP_ENTITY;
const AddEntityIcon = ICONS?.ADD_BUTTON_WHITE;

export default function PullTab({
  disabled,
  isActive,
  setIsActive,
  conciergeLoading,
  cardTimeout,
  setCardTimeout,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const pullTabRef = useRef(null);
  const currentEntityName =
    useSelector((state) => state.refreshToken.data)?.entity?.entity_name ?? " ";

  const { markerData, cnfBtnClicked } = useSelector(
    (s) => s.multiEntitySwitcherSlice,
  );

  const { multiEntityFavouriteLoading } = useSelector(
    (state) => state.multientity,
  );
  let pullTabIsSupressed =
    JSON.parse(sessionStorage.getItem("suppressPullTab")) ?? false;
  // is the tab being currently hovered on?

  const subEntitySelected =
    JSON.parse(sessionStorage.getItem("subEntitySelected")) ?? false;

  const [switcherAnimation, setSwitcherAnimation] = useState(false);

  const [isMultiPopupOpen, setIsMultiPopupOpen] = useState(false);
  const [selectedCardId, setSelectedCardId] = useState("");

  const [availableEntities, setAvailableEntities] = useState([]);

  const availableEntitiesSorted = availableEntities.sort(
    (a, b) => b.getIsActive() - a.getIsActive(),
  );

  const favEntitiesS = sessionStorage.getItem("favourite_entities") ?? "[]";
  const selectedEntitiesS = sessionStorage.getItem("selectedCards");

  // prioritise selected entities over favourite entities
  const favEntities = JSON.parse(selectedEntitiesS ?? favEntitiesS);

  function handleAvailableEntities() {
    // prioritise selected entities over favourite entities
    // yes this is written twice
    const favEntities = JSON.parse(selectedEntitiesS ?? favEntitiesS);
    setIsActive(true);
    if (location.pathname === "/home") {
      if (location?.state) {
        setSwitcherAnimation(true);
        navigate(location.pathname, { replace: true, state: null });
      }
    }

    // check for empty array
    if (
      favEntities.length + GlobalConfiguration?.lengthCheckOne >
        GlobalConfiguration?.lengthCheckZero &&
      location?.state
    ) {
      setTimeout(
        () => {
          setIsActive(false);
          setSwitcherAnimation(false);
        },
        (favEntities.length + GlobalConfiguration?.lengthCheckOne) *
          CONFIG.ANIMATION_LENGTH_SHORT,
      );
    } else {
      setTimeout(() => {
        setIsActive(false);
      }, CONFIG.ANIMATION_LENGTH_LONG);
    }

    const entityList = favEntities.map((e) => {
      return new Entity(
        e.id,
        e.sub_entity_name,
        e.sub_entity_pan,
        e.primary_entity_id,
        e.primary_entity_name,
        e.primary_user,
        e.sub_user,
        e.sub_entity_id,
        e.favourite === "Y",
      );
    });

    const responseSessionData =
      JSON.parse(sessionStorage.getItem("primary_entity_data")) ?? {};
    const _primaryEntityName = responseSessionData?.entity?.entity_name ?? "";
    const _primaryEntityId = responseSessionData?.entity?.entity_id ?? "";
    const _primaryEntityPan = responseSessionData?.entity?.entity_pan ?? "";
    const _primaryUser = responseSessionData?.employees?.user_id ?? "";

    let cEntity = new Entity(
      "-1",
      _primaryEntityName,
      _primaryEntityPan,
      _primaryEntityId,
      _primaryEntityName,
      _primaryUser,
      _primaryEntityName,
      _primaryEntityId,
      false,
    );
    setAvailableEntities([cEntity, ...entityList]);
  }
  useEffect(() => {
    handleAvailableEntities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cnfBtnClicked]);

  useEffect(() => {
    setAvailableEntities((ae) =>
      ae.map((e) => {
        const currentEntityId = sessionStorage.getItem("entity_id");
        const currentUserId = sessionStorage.getItem("user_id");

        if (e.getId() === "-1") {
          /// special case the primary entity (id = -1)
          if (e.getPrimaryEntityId() === currentEntityId) {
            e.setIsActive(true);
          } else {
            e.setIsActive(false);
          }
          return e;
        } else if (
          e.getSubEntityId() === currentEntityId &&
          e.getSubUser() === currentUserId
        ) {
          e.setIsActive(true);
        } else {
          e.setIsActive(false);
        }
        return e;
      }),
    );
  }, [markerData, cnfBtnClicked]);

  let mql = window.matchMedia(
    `(width <= ${ScreenSizeConfiguration?.tabviewEnd}px)`,
  );

  const [isMobile, setIsMobile] = useState(mql.matches);
  useEffect(() => {
    const f = (mql) => {
      setIsMobile(mql.matches);
    };
    mql.addEventListener("change", f);
    return () => {
      mql.removeEventListener("change", f);
    };
  }, []);

  const handleEntityDismiss = (idx) => {
    if (idx === "-1") {
      toast.info("Primary entity cannot be removed", toast_position);
      return;
    }

    const selectedEntities =
      JSON.parse(sessionStorage.getItem("selectedCards")) ??
      JSON.parse(sessionStorage.getItem("favourite_entities"));

    const r = selectedEntities.filter((ae) => ae.id !== idx);

    sessionStorage.setItem("selectedCards", JSON.stringify(r));
    setAvailableEntities((ae) => ae.filter((a) => a.getId() !== idx));
  };

  const handleEntityFavourite = (idx) => {
    const selectedEntities =
      JSON.parse(sessionStorage.getItem("selectedCards")) ??
      JSON.parse(sessionStorage.getItem("favourite_entities"));
    const r = selectedEntities.map((e) => {
      if (e.id === idx) {
        if (e.favourite === "Y") e.favourite = "N";
        else e.favourite = "Y";
      }
      return e;
    });
    sessionStorage.setItem("selectedCards", JSON.stringify(r));
    setAvailableEntities((ae) =>
      ae.map((e) => {
        if (e.getId() === idx) {
          if (e.getIsFavourite()) e.setIsFavourite(false);
          else e.setIsFavourite(true);
        }
        return e;
      }),
    );
  };

  const getIsFavouriteDisabled = (primaryEntityId) => {
    const isIt =
      (JSON.parse(sessionStorage.getItem("primary_entity_data"))?.entity
        ?.entity_id ?? "") !== sessionStorage.getItem("entity_id");
    return isIt;
  };

  function doLogout() {
    dispatch(setMultipleEntity());
    dispatch(setShowReloginModalFalse());
    dispatch(logout());
    dispatch(xpentraLogoutSliceReset());
    navigate("/login");
    sessionStorage.clear();
  }

  function doConciergeLogin(
    primaryEntityId,
    primaryUserId,
    subEntityId,
    subUserId,
    id,
  ) {
    (async () => {
      setCardTimeout(true);
      setSelectedCardId(id);
      setSwitcherAnimation(false);
      const currentEntityId = sessionStorage.getItem("entity_id");
      const currentUserId = sessionStorage.getItem("user_id");

      // if we are not the primary entity, first go to primary entity.  if we
      // are already the primary entity. Do not go to the primary entity
      if (currentEntityId !== primaryEntityId) {
        const response = await dispatch(
          conciergeLogin({
            primary_entity_id: primaryEntityId,
            primary_user_id: primaryUserId,
            sub_entity_id: currentEntityId,
            sub_user_id: currentUserId,
          }),
        );

        if (!response?.payload?.status) {
          doLogout();
        }
      }
      // if we are going from sub entity to primary entity. my sub and primary
      // entities will be the same if this is the case, we dont want to go from
      // primary to sub since we originally wanted to go the primary
      if (primaryEntityId !== subEntityId && subEntityId.trim() !== "") {
        const response = await dispatch(
          conciergeLogin({
            primary_entity_id: primaryEntityId,
            primary_user_id: primaryUserId,
            sub_entity_id: subEntityId,
            sub_user_id: subUserId,
          }),
        );
        if (!response?.payload?.status) {
          doLogout();
        }
      }
      setTimeout(() => {
        setSelectedCardId("");
        dispatch(triggerEntityChange());

        setAvailableEntities((ae) => {
          ae.map((e) => {
            return e;
          });
          return ae;
        });
        setCardTimeout(false);
        toast.dismiss();
        CommonToast({
          text: "Entity swapped successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, 3000);
    })();
  }

  useEffect(() => {
    if (
      favEntities.length + GlobalConfiguration?.lengthCheckOne >
        GlobalConfiguration?.lengthCheckZero &&
      location?.state
    ) {
      setTimeout(
        () => {
          setIsActive(false);
          setSwitcherAnimation(false);
        },
        (favEntities.length + GlobalConfiguration?.lengthCheckOne) *
          CONFIG.ANIMATION_LENGTH_SHORT,
      );
    } else {
      setTimeout(() => {
        setIsActive(false);
      }, CONFIG.ANIMATION_LENGTH_LONG);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isActive &&
        pullTabRef.current &&
        !pullTabRef.current.contains(event.target)
      ) {
        setIsActive(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isActive]);

  return (
    (!pullTabIsSupressed || subEntitySelected) && (
      <>
        {isMultiPopupOpen && (
          <MultiEntityPopup
            isMultiPopupOpen={isMultiPopupOpen}
            setIsMultiPopupOpen={setIsMultiPopupOpen}
          />
        )}
        <div
          ref={pullTabRef}
          className={`${
            isActive ? "translate-x-1" : ""
          } fixed h-full flex-row py-padding-xs flex z-max-zindex transition-all pointer-events-none
          `}
        >
          <div
            onMouseEnter={() => {
              if (isMobile) return;
              if (!disabled) {
                setIsActive(true);
              } else {
                CommonToast({
                  text: "Entity switching restricted on current page",
                  icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                  variant: "var(--error)",
                  btnProps: {
                    isDisabled: false,
                    enabledTextColor: "var(--text-primary)",
                    enabledBgColor: "var(--primary-bg)",
                  },
                });
              }
            }}
            onMouseLeave={() => {
              if (!disabled && !switcherAnimation) setIsActive(false);
            }}
            className={`${
              isActive ? "w-auto flex" : "w-width-base hidden"
            }  bg-primary-card pointer-events-auto  rounded-xl rounded-tr-none max-w-pulltab-open min-w-[calc(2 * var(--navbar-breadcrumb-height))]
`}
          >
            <div className="entity-box-container  pt-padding-md pb-padding-md pl-padding-md  h-full w-full flex flex-col gap-gap-sm justify-between">
              <div className="entity-title-box flex flex-row gap-gap-sm">
                <div className="w-icon-md h-icon-md">
                  <img
                    src={SwapEntityIconWithCircle}
                    alt=""
                  />
                </div>
                <div className="text-text-primary pr-padding-xl mr-margin-xl text-font-sm font-semibold">
                  Switch entity
                </div>
              </div>
              <hr className="border-primary-bg  mr-margin-md" />
              <div
                className={`entity-edit-list-btn mr-margin-md bg-primary-nav-act  p-padding-sm h-auto flex flex-row gap-gap-sm items-center rounded-xl text-text-primary text-font-sm ${!multiEntityFavouriteLoading ? "hover:bg-Multi-entity-editlist-hover cursor-pointer" : "cursor-default opacity-light-opacity"}`}
                onClick={() => {
                  setIsMultiPopupOpen(true);
                }}
              >
                <div className="w-icon-sm h-icon-sm">
                  <SVGComponent
                    url={
                      availableEntities.length > 1
                        ? EditWithWhiteCircleIcon
                        : AddEntityIcon
                    }
                    color={
                      availableEntities.length > 1 ? "" : "var(--text-primary)"
                    }
                    width="var(--icon-sm)"
                    alt=""
                  />
                </div>
                {availableEntities.length > 1 ? (
                  <div>Edit list</div>
                ) : (
                  <div>Add entities</div>
                )}
              </div>
              <div
                className="multi-entity-scroll-container pr-padding-md flex pt-padding-sm flex-col gap-gap-md overflow-y-scroll overflow-x-hidden flex-1"
                style={{
                  height: "auto",
                }}
              >
                {availableEntitiesSorted.map((e, i) => (
                  <EntityDetailsBox
                    dismissAdvice={() => handleEntityDismiss(e.getId())}
                    pName={e.getPrimaryEntityName()}
                    sName={e.getSubEntityName()}
                    pan={e.getSubEntityPan()}
                    key={e.getId()}
                    i={e.getId()}
                    switcherAnimation={switcherAnimation}
                    selectedCardId={selectedCardId}
                    disabled={e.getIsActive()}
                    loading={conciergeLoading}
                    cardTimeout={cardTimeout}
                    duration={i}
                    isFavourite={e.getIsFavourite()}
                    isFavouriteDisabled={getIsFavouriteDisabled(
                      e.getPrimaryEntityId(),
                    )}
                    favouriteClickAdvice={() =>
                      handleEntityFavourite(e.getId())
                    }
                    onSelect={() => {
                      doConciergeLogin(
                        e.getPrimaryEntityId(),
                        e.getPrimaryUser(),
                        e.getSubEntityId(),
                        e.getSubUser(),
                        e.getId(),
                      );
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
          <div
            onMouseEnter={() => {
              if (isMobile) return;
              if (!disabled) {
                setIsActive(true);
              } else {
                CommonToast({
                  text: "Entity switching restricted on current page",
                  icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                  variant: "var(--error)",
                  btnProps: {
                    isDisabled: false,
                    enabledTextColor: "var(--text-primary)",
                    enabledBgColor: "var(--primary-bg)",
                  },
                });
              }
            }}
            onMouseLeave={() => {
              if (isMobile) return;
              if (!disabled && !switcherAnimation) setIsActive(false);
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (!disabled && !switcherAnimation) setIsActive((a) => !a);
            }}
            className={`flex pointer-events-auto flex-col multi-entity-pulltab  gap-gap-sm w-auto px-padding-sm items-center justify-start bg-primary-card border-primary-bg border-l py-padding-md  ml-0 rounded-r-xl text-text-primary  cursor-pointer text-font-xs
              relative 
              top-[var(--navbar-breadcrumb-height)] Qmd:top-top-base
              `}
          >
            <div
              className={`entity-switcher-icon-div flex flex-row h-icon-md w-icon-md 
              ${disabled ? "opacity-light-opacity" : ""}
                `}
            >
              <img
                src={SwapEntityIcon}
                alt=""
              />
            </div>
            <div
              className={`entity-switcher-name-div hidden Qmd:inline truncate text-vertical
              ${disabled ? "opacity-light-opacity" : ""}
              `}
            >
              {currentEntityName}
            </div>
          </div>
        </div>
      </>
    )
  );
}
